export const primary = "#1E85B5";
export const primaryLight = "#A0C8DB";
export const primaryDark = "#196C98";
export const listItemStyle = "no-underline text-primary hover:primary-dark hover:font-bold";
